import React from "react";
import { useProvider } from "../components/StateProvider";
import { Link } from "react-router-dom";
const Appbar = () => {
  const { user, auth } = useProvider();
  const logout = () => {
    auth
      .signOut()
      .then(() => {})
      .catch((error) => {
        alert(error.message);
      });
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-4">
        <Link to="/" className="text-white navbar-brand">
          <h5>
            <i className="fas fa-music mr-2" />
            Musicify
          </h5>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto text-white text-center">
            <li className="nav-item mr-4">
              <h5>{user.displayName}</h5>
            </li>
            <li className="nav-item mr-4" onClick={logout}>
              <h5>Signout</h5>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Appbar;
